var map = {
	"./audio.svg": "32fd",
	"./ball-triangle.svg": "873c",
	"./bars.svg": "ef9f",
	"./circles.svg": "725e",
	"./grid.svg": "91bc",
	"./hearts.svg": "6413",
	"./oval.svg": "eb51",
	"./puff.svg": "f55d",
	"./rings.svg": "63f2",
	"./spinning-circles.svg": "dfc5",
	"./tail-spin.svg": "c38d",
	"./three-dots.svg": "f1bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51c9";